module.exports = __webpack_public_path__ + "img/[擦汗].b8a350ff.svg";